<template>
  <div class="monthly" >
    <b-row class="headline">
      <b-col sm="" md="" class="header">
        <slot name="txtHeader">Aufladung</slot>
      </b-col>
      <b-col sm="" md="" class="change-link">
          <a @click.prevent="goToTopUpStep()" class="linkChange">
            <slot name="txtChange">ändern</slot>
          </a>
      </b-col>
    </b-row>
    <b-row class="top-up-content">
      <b-col sm="" md="">
        <slot name="txtWithoutAuto">
          <p><strong>-</strong><br/>
            Du hast keine Aufladung ausgewählt</p>
        </slot>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { stepName as topUpStep } from './EnterTopUpAndPayment.vue'

export default {
  name: 'ShowWithoutAuto',
  props: {
    topUpInfo: {
      type: Object
    }
  },
  methods: {
    goToTopUpStep: function () {
      this.goToStep(topUpStep)
    },
    ...mapMutations('activation', [
      'goToStep'
    ])
  }
}
</script>
